'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var InternalCheckbox_web = require('../../internal/InternalCheckbox/InternalCheckbox.web.cjs');
var Checkbox_web_styles = require('./Checkbox.web.styles.cjs');

/**
 * An input control that allows a user to select one or more options from a number of choices
 *
 * {@link https://aviary.supernova-docs.io/latest/components/checkbox/overview-LQAQYZgr | Documentation}
 *
 * @scope Core
 */ const Checkbox = ({ children, alignment = "center", customCss, ...internalProps })=>{
    const labelStyles = alignment === "top" && Checkbox_web_styles.topAlignment;
    return /*#__PURE__*/ jsxRuntime.jsx(InternalCheckbox_web.InternalCheckbox, {
        ...internalProps,
        css: customCss,
        labelStyle: labelStyles,
        children: children
    });
};

exports.Checkbox = Checkbox;
//# sourceMappingURL=Checkbox.web.cjs.map
